module.exports = __webpack_public_path__ + "img/play_for_work.75dacf72.svg";